export const defaultColor = "#929292";
